import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@fontsource/instrument-serif/400.css';
import '@fontsource/instrument-serif/400-italic.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/noto-sans-sc/400.css';
import '@fontsource/noto-sans-sc/500.css';
import '@fontsource/noto-sans-sc/700.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";
import { installChunkLoadRecovery } from './appVersion';

import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import localeData from 'dayjs/plugin/localeData';
dayjs.extend(localeData);
dayjs.locale('zh-cn');

installChunkLoadRecovery();

if( process.env.NODE_ENV === 'production' ){
  Sentry.init({
    dsn: "https://86276beb6768435fa2d678413a5d9e3f@o4505582055456768.ingest.sentry.io/4505582066335744",
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: ["https://picsect.com"],
      }),
      new Sentry.Replay(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(({ name, delta, rating, id }) => {
  if (process.env.NODE_ENV !== 'production' || rating !== 'poor') return;
  Sentry.captureMessage(`Web Vital: ${name}`, {
    level: 'warning',
    tags: { vital: name, rating },
    extra: { value: delta, id },
  });
});
